import React, { useEffect, useRef } from 'react'
import { Html5QrcodeScanner } from 'html5-qrcode'

export default function QRScanner({ onScanSuccess, onScanError }) {
  const scannerRef = useRef(null)

  useEffect(() => {
    if (!scannerRef.current) return

    const scanner = new Html5QrcodeScanner(
      'qr-reader',
      {
        qrbox: {
          width: 250,
          height: 250,
        },
        fps: 5,
      },
      false
    )

    scanner.render(
      (decodedText) => {
        onScanSuccess(decodedText)
      },
      (error) => {
        onScanError(error)
      }
    )

    return () => {
      scanner.clear().catch(error => {
        console.error('Failed to clear html5QrcodeScanner.', error)
      })
    }
  }, [onScanSuccess, onScanError])

  return <div id="qr-reader" ref={scannerRef} className="qr-scanner-container" />
}